
export const SignIn = async ( firebase, email, password, setUser, setAuthUser ) => {

  try {
    await firebase
      .auth()
      .signOut()

    const res = await firebase
      .auth()
      .signInWithEmailAndPassword( email, password )

    return {
      status: 200,
      user: res.user
    }
  }
  catch ( error ) {
    console.log( 'sign-in', { error } )

    setUser( null )
    setAuthUser( null )

    return {
      status: 400,
      error
    }
  }
}

export default SignIn